import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthService} from './auth.service';
import {RoleService} from './role.service';

@Injectable({
  providedIn: 'root'
})
export class LeadManagementGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private roleService: RoleService,
    private router: Router,
  ) {}

  canActivate(): boolean {
      if (!this.auth.isAuthenticated()) {
          void this.router.navigate(['/login']);
          return false;
      }

    const userInfo = this.auth.getCurrentUserInfo();
    if (this.roleService.canAccessLeadManagement(userInfo?.role)) {
      return true;
    }

    this.router.navigate([this.roleService.getDefaultRoute(userInfo?.role)]);
    return false;
  }
}
